import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer>
      <h2>CodeFellow</h2>
    </footer>
  );
};

export default Footer;
